import { z } from 'zod';
/**
 * Cursor pagination for every `View More` list (AC-GL-02): pages append via
 * `nextCursor`; `null` means the pager hides. One shape for all ~12 list
 * screens, so `usePaginatedList` can be written once.
 */
export const Paginated = (item) => z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
    /** Optional — drives the "345 Connections" count rows (AC-GL-01). */
    total: z.number().int().nonnegative().optional(),
});
export const CursorQuery = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(50).default(20),
});
//# sourceMappingURL=pagination.js.map